import React from 'react'
import clsx from 'clsx'
import SvgIcon from '@mui/material/SvgIcon'
import { IconProps } from './index'
import styles from './Icon.module.scss'

const ShareOutlineIcon: React.FC<IconProps> = ({ className, alt }) => {
  return (
    <SvgIcon
      className={clsx(styles.IconStroke, className)}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5199 13.8562C8.41335 13.8562 4.75874 15.2578 3 19.087V17.9131C3 12.0814 7.31876 8.57504 12.5199 8.57504V6.04185C12.5199 5.15559 13.5727 4.67548 14.2595 5.2495L20.6268 10.5706C21.1133 10.9756 21.1264 11.7116 20.653 12.133L14.2858 17.8157C13.6073 18.4202 12.5199 17.9471 12.5199 17.0456V13.8562Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export default ShareOutlineIcon
